import { render, staticRenderFns } from "./ClaimBalance.vue?vue&type=template&id=6ffbdd2e&"
import script from "./ClaimBalance.vue?vue&type=script&lang=js&"
export * from "./ClaimBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VCard,VDivider,VList,VListItem,VListItemAvatar,VListItemContent,VListItemGroup,VListItemSubtitle,VListItemTitle,VProgressCircular,VSheet})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ffbdd2e')) {
      api.createRecord('6ffbdd2e', component.options)
    } else {
      api.reload('6ffbdd2e', component.options)
    }
    module.hot.accept("./ClaimBalance.vue?vue&type=template&id=6ffbdd2e&", function () {
      api.rerender('6ffbdd2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Page/EssAdmin/Claim/ClaimBalance/ClaimBalance.vue"
export default component.exports